import { Link } from "react-router-dom";

export interface Crumb {
  name: string;
  path?: string;
}

interface BreadcrumbsProps {
  items: Crumb[];
  tone?: "light" | "dark";
}

export default function Breadcrumbs({ items, tone = "light" }: BreadcrumbsProps) {
  const base = tone === "dark" ? "text-background-300" : "text-foreground-500";
  const current = tone === "dark" ? "text-background-50" : "text-foreground-800";

  return (
    <nav aria-label="面包屑导航" className={`text-xs ${base}`}>
      <ol className="flex flex-wrap items-center gap-1.5">
        {items.map((item, idx) => {
          const isLast = idx === items.length - 1;
          return (
            <li key={`${item.name}-${idx}`} className="flex items-center gap-1.5">
              {item.path && !isLast ? (
                <Link
                  to={item.path}
                  className="cursor-pointer transition-colors duration-200 hover:text-primary-600"
                >
                  {item.name}
                </Link>
              ) : (
                <span className={isLast ? current : ""}>{item.name}</span>
              )}
              {!isLast && (
                <span className="w-3.5 h-3.5 flex items-center justify-center opacity-60">
                  <i className="ri-arrow-right-s-line" />
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}